import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, Modal, Spacer, Typography } from '@telus-uds/components-web';

import request from '../../../utils/request';
import { useLocalizedStringsContext } from '../../../context/LocalizedStringsContext';
import { Button as ActionButton } from './css';

const CancelOrder = ({ orderData, fetchOrders }) => {
  const { id, isQuoteReference } = orderData;
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { confirmationDialog, cancel, cancelConfirmation },
    formButtons: { confirmButtonLabel, cancelButtonLabel }
  } = localizedStrings;

  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCancelOrder = () => {
    request.delete(`/orders/${id}`).then(() => {
      fetchOrders();
      setIsModalOpen(false);
    });
  };

  if (isQuoteReference) return null;

  return (
    <>
      <ActionButton className="action-button" onClick={() => setIsModalOpen(true)}>
        {cancel}
      </ActionButton>
      <Modal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      >
        <Typography variant={{ size: 'h2' }}>{confirmationDialog}</Typography>
        <Spacer space={1} />
        <p>{cancelConfirmation}</p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'flex-end', marginTop: '1rem' }}>
          <Button
            type="button"
            variant={{ priority: 'low' }}
            onPress={() => setIsModalOpen(false)}
          >
            {cancelButtonLabel}
          </Button>
          <Button
            type="button"
            variant={{ priority: 'high', semantic: 'danger' }}
            onPress={handleCancelOrder}
          >
            {confirmButtonLabel}
          </Button>
        </div>
      </Modal>
    </>
  );
};

CancelOrder.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.object).isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default CancelOrder;
